import {
    EXHIBITOR_SPOTLIGHT_EN_DOCS,
    EXHIBITOR_SPOTLIGHT_EXTRA_NEWS,
} from "@/data/exhibitorSpotlightEnDocs";
import { SPOTLIGHT_NEWS_0407 } from "@/data/news0407Generated";

const spotlightImage = (name) =>
    require("@/assets/image/exhibitor-spotlight/" + name);

const sortNewsByDateDesc = (left, right) =>
    right.date.localeCompare(left.date);

const EXHIBITOR_SPOTLIGHT_BASE_NEWS = [
    {
        id: "cscec-third-bureau",
        title: "2026江苏绿色低碳建筑国际博览会展商|中建八局第三建设有限公司",
        date: "2026-03-03",
        displayDate: "2026年3月3日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_1_1.png"), alt: "中建八局第三建设有限公司" },
            { type: "paragraph", text: "中建八局第三建设有限公司，隶属于中国建筑股份有限公司，1983年在南京由基建工程兵集体转业改编，2007年整体改制为现单位。公司拥有房屋建筑工程施工总承包特级资质和建筑行业工程设计甲级资质，以及市政工程、机电工程施工总承包壹级资质以及多项专业承包壹级资质。先后被评为创鲁班奖工程特别荣誉企业、全国建筑业竞争力百强企业、全国优秀施工企业、全国建筑业AAA级信用企业、江苏省安全生产先进单位、江苏省科技进步和技术创新先进单位等。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "“天蝉”TC-PC1.0施工机器人系统" },
            { type: "image-group", images: [{ src: spotlightImage("zs_1_3.png"), alt: "天蝉TC-PC1.0施工机器人系统" }] },
            { type: "paragraph", text: "“天蝉”TC-PC1.0施工机器人系统由钢平台及支撑系统、挂架及防护系统、顶升系统、分布式智能施工系统、智能控制系统五大系统组成，悬挂式智能施工装备涵盖吊装、整平、振捣、覆膜等主要工序。该系统软硬件均具备可扩展性，可根据需求自由增减施工装备种类和数量，已打通装配式住宅混凝土施工场景主要工序的装备化作业链条，特别适用于100米以下的装配式住宅项目。" },
            { type: "product-heading", text: "“S-D-S”三元体系低碳胶凝材料" },
            { type: "paragraph", text: "“S-D-S”三元体系低碳胶凝材料是以工业固废（矿粉、钢渣、脱硫灰）为主材，通过粉磨加复配的工艺制备。经材料配合比调整，可实现50%至100%的取代水泥进行部分工程部位施工。该材料与土壤结合性能好，水化热低，生产碳排放低。" },
            { type: "product-heading", text: "建筑运维系统" },
            { type: "image-group", images: [{ src: spotlightImage("zs_1_2.png"), alt: "建筑运维系统" }] },
            { type: "paragraph", text: "基于BIM的智慧运维管理平台，面向现代建筑后勤管理安全要求高、管理难度大等痛点，以数字孪生为基础，覆盖医院、学校、场馆、园区、社区等全业务场景，实现建筑楼宇安全智能诊断分析与运维可视化管理，保障建筑更加安全、节能、高效运行。" },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "展会同期将举办“天蝉”TC-PC技术产业创新交流会，邀请主管部门、行业协会、高校、相关企业等代表，介绍产品核心技术、创新点、工程应用成效、行业推广价值，同时还将举办有关合作签约仪式。" },
            { type: "section-heading", text: "目标观众" },
            { type: "paragraph", text: "我们诚邀房地产开发企业、建筑设计院所、高校科研机构、智能建造及绿色建材上下游企业、物业运维单位、行业协会等莅临参观。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "otis-china",
        title: "2026江苏绿色低碳建筑国际博览会展商|奥的斯电梯（中国）有限公司",
        date: "2026-03-05",
        displayDate: "2026年3月5日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_2-1.png"), alt: "奥的斯电梯（中国）有限公司" },
            { type: "paragraph", text: "奥的斯是全球知名的电梯和自动扶梯制造商、安装和服务提供商，连续蝉联全球电梯制造商十强榜首。作为最早进入中国市场的电梯公司之一，奥的斯在华深耕40余载，始终坚持“扎根中国，服务世界”，助力中国城市高质量发展，为众多地标建筑、基础设施及住宅等项目提供电扶梯产品、服务及现代化更新解决方案，并持续响应国家号召，助力城市更新和老旧电梯更新民生工程。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "奥的斯Gen3 Comfort智能电梯" },
            { type: "image-group", images: [{ src: spotlightImage("zs_2-2.jpg"), alt: "奥的斯Gen3 Comfort智能电梯" }] },
            { type: "paragraph", text: "奥的斯Gen3 Comfort智能电梯以好房子“安全、舒适、绿色、智慧”为标准，专为住宅焕新设计，融入无障碍设计、适老化关怀及儿童宠物友好理念，打造适配好房子的理想“好电梯”。" },
            { type: "product-heading", text: "奥的斯万能门机" },
            { type: "image-group", images: [{ src: spotlightImage("zs_2-3.jpg"), alt: "奥的斯万能门机" }] },
            { type: "paragraph", text: "奥的斯万能门机全系适配，覆盖所有电梯型号，稳定兼容，即装即用，满足老旧电梯更新改造需求。行业领先的IP65门机防护等级，防止粉尘进入，任何角度低压喷射无影响，运行安全可靠。" },
            { type: "product-heading", text: "奥的斯ReGen能源再生变频技术" },
            { type: "image-group", images: [{ src: spotlightImage("zs_2-4.png"), alt: "奥的斯ReGen能源再生变频技术" }] },
            { type: "paragraph", text: "奥的斯ReGen能源再生变频技术能够将电梯运行过程中产生的势能转化为清洁能源，并回馈至建筑物电力系统中，实现能源循环利用。与未采用此技术的常规驱动系统相比，最多可减少约75%的电耗。" },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "同期将举办奥的斯现代化更新研讨交流活动，聚焦“好房子”理念下如何打造“好电梯、好方案”，分享奥的斯在电梯更新改造领域的创新解决方案及领先优势，持续助力城市更新。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "奥的斯提供覆盖电梯研发、制造、安装、维保、现代化更新的全生命周期管理，面向有电梯更新改造、电梯设备采购、电梯维修维保服务等需求的政企和个人，提供绿色、低碳、智能、安全的电梯产品与服务。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn。" },
        ],
    },
    {
        id: "huawei",
        title: "2026江苏绿色低碳建筑国际博览会展商|华为技术有限公司",
        date: "2026-03-06",
        displayDate: "2026年3月6日",
        blocks: [
            { type: "logo", src: spotlightImage("640 (1).png"), alt: "华为技术有限公司" },
            { type: "paragraph", text: "华为是全球领先的ICT基础设施和智能终端提供商，愿景与使命是把数字世界带入每个人、每个家庭、每个组织，构建万物互联的智能世界。华为聚焦ICT技术，面向消费者、运营商客户、政企三类客户，携手生态及伙伴提供产品解决方案和服务。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "华为鸿蒙智家解决方案" },
            { type: "paragraph", text: "以智能主机作为全屋的智慧大脑，基于PLC、Wi-Fi、蓝牙、星闪等稳定连接方式，连接全屋智能设备，实现对照明、遮阳、冷暖新风、安防、网络、用水、影音娱乐、能耗、家电、家具家私等子系统的统一掌控，打造可成长、可适配、低碳化的全场景人车家智慧生活体验。" },
            { type: "product-heading", text: "问界M9" },
            { type: "paragraph", text: "华为与赛力斯联合打造的新能源高端旗舰SUV，搭载华为全栈智能技术，提供增程、纯电两种动力，配备零重力座椅等豪华配置，兼顾家庭出行与商务接待，是兼具智能、舒适与实用性的全景智慧旗舰SUV。" },
            { type: "product-heading", text: "Mate80系列" },
            { type: "paragraph", text: "Mate80系列是2026年春晚首个且唯一手机直播用机，采用业界首创的双环设计与全金属设计，兼具精致性与可靠性。" },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "聚焦人工智能加住房城乡建设、绿色智慧人居、智能建造产业发展核心方向，打造“未来家，AI生活”专业技术交流，邀请房地产、建筑、家装企业合作伙伴分享落地案例。" },
            { type: "section-heading", text: "目标观众" },
            { type: "paragraph", text: "我们诚邀房地产开发商、酒店运营方、康养公司、集成商、家装行业等莅临参观。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "nippon-paint",
        title: "2026江苏绿色低碳建筑国际博览会展商|立邦涂料（中国）有限公司",
        date: "2026-03-07",
        displayDate: "2026年3月7日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_4_1.png"), alt: "立邦涂料（中国）有限公司" },
            { type: "paragraph", text: "立时集团于1962年创立于新加坡，1992年进入中国并取名“立邦”，总部位于上海，拥有70余家生产基地和近1.1万名员工。秉持“刷新美好生活空间”的使命，立邦业务覆盖建筑与工业领域，在建筑工程领域致力于用科技构建客户首选的全场景涂装集成方案专业服务平台，服务于鸟巢、大兴机场等国家级重点项目。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "立邦“好房子”场景解决方案" },
            { type: "image-group", images: [{ src: spotlightImage("zs_4_2.jpg"), alt: "立邦好房子场景解决方案" }] },
            { type: "paragraph", text: "该方案覆盖外墙、地下车库、既有建筑更新改造、绿色环保室内装饰装修、不漏不渗屋面、全龄友好社区场地等场景。其中隔声保温地坪涂装体系可有效降低噪音20至30分贝，Ufast快涂优楼道翻新方案则可大幅提升改造效率，减少对居民正常生活的影响。" },
            { type: "product-heading", text: "立邦优能辐射致冷涂料" },
            { type: "image-group", images: [{ src: spotlightImage("zs_4_3.jpg"), alt: "立邦优能辐射致冷涂料" }] },
            { type: "paragraph", text: "优能辐射致冷涂料通过“高效隔热”与“主动散热”双重机制实现被动降温。实测显示，涂刷后屋顶外表面温度可下降20摄氏度，室内体感温度较普通涂料降低6摄氏度，可有效解决工业厂房物料变质与人员舒适度问题，助力企业绿色转型与双碳目标落地。" },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "同期将举办“好房子”建设及更新涂装技术解决方案发布活动，聚焦地域特色发布专项技术解决方案，汇聚行业专家与相关领导，共话“好房子”建设路径，搭建政企对接与行业交流平台。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀学校、医院、保障房、市政、公建单位，以及既有建筑节能改造、翻新、维保项目的节能服务商、物业公司、各类开发企业、总承包单位等莅临参观。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn。" },
        ],
    },
    {
        id: "jibs",
        title: "2026江苏绿色低碳建筑国际博览会展商|江苏省建筑科学研究院有限公司",
        date: "2026-03-08",
        displayDate: "2026年3月8日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_5_1.png"), alt: "江苏省建筑科学研究院有限公司" },
            { type: "paragraph", text: "江苏省建筑科学研究院有限公司成立于1958年，是国内建设行业规模较大、产业化程度较高的综合性科学研究和技术开发机构。拥有控股子公司9家，形成新材料、工程咨询和特种施工三大主业，业务遍及全国30多个省、自治区、直辖市及海外。" },
            { type: "paragraph", text: "公司员工6000余人，拥有包括中国工程院院士、国务院政府特殊津贴专家等高层次人才在内的专业团队，建设并运行全国重点实验室、国家检测检验中心等科研平台，累计获得1100余件国家发明专利及40余项科技进步奖，成果广泛应用于长江三峡、京沪高铁、港珠澳大桥、川藏铁路等国家重点工程。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "超高性能混凝土（UHPC）" },
            { type: "image-group", images: [{ src: spotlightImage("zs_5_2.jpg"), alt: "超高性能混凝土" }] },
            { type: "paragraph", text: "超高性能混凝土具有极高强度、韧性和耐久性。公司突破混凝土超高强度、超高韧性和超高抗力技术瓶颈，发明了常规浇筑和养护条件下抗压强度大于200MPa的超高性能混凝土材料，成果已应用于南京长江五桥、上海松浦大桥、宁波西洪大桥等项目。" },
            { type: "product-heading", text: "AIBMS低碳智慧建筑运维管理系统" },
            { type: "paragraph", text: "系统以AI、BIM、IoT等技术为支撑，集成楼宇各类设备和传感器，实现建筑空间、设施设备、环境健康、人员行为、能碳监测的智慧运营管理。系统以数字孪生为底座、大模型为大脑、智能体为手脚，构建贯穿“感知、分析、决策、执行、反馈”的建筑运维智能体，并深度集成“光储直柔”新型微电网架构。" },
            { type: "product-heading", text: "建筑低碳运行智能诊断测试系统" },
            { type: "image-group", images: [{ src: spotlightImage("zs_5_3.jpg"), alt: "建筑低碳运行智能诊断测试系统一" }, { src: spotlightImage("zs_5_4.jpg"), alt: "建筑低碳运行智能诊断测试系统二" }] },
            { type: "paragraph", text: "系统集成温度、热流、风速、电能、流量等多维度检测与诊断模块，可根据项目需求灵活组合测试方案。系统内置标准化计算与AI优化功能，支持自主编制算法，一套系统可衍生多种测试方案，大幅降低采购成本、提升检测效率。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们可提供绿色低碳建筑技术、材料、咨询及智慧运维整体解决方案，诚邀各地市建设主管部门、各级城投公司、房地产开发商、建材企业及建筑施工、设计、运营相关单位等莅临参观。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn。" },
        ],
    },
    {
        id: "lazzen",
        title: "2026江苏绿色低碳建筑国际博览会展商|上海良信电器股份有限公司",
        date: "2026-03-13",
        displayDate: "2026年3月13日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_6_1.png"), alt: "上海良信电器股份有限公司" },
            { type: "paragraph", text: "LAZZEN良信成立于1999年，定位于“智慧低压电气解决方案专家”，专注终端电器、配电电器、控制电器、智能配电、智慧人居等领域的研发、生产、销售和服务，产品及解决方案广泛应用于发电端、输配电、用电端各场景，业务覆盖信息通讯、新能源、建筑等多个领域。" },
            { type: "paragraph", text: "良信始终坚持“成就客户”的核心价值观，以客户需求驱动产品研发，研发中心被认定为“国家企业技术中心”，并设立“企业博士后科研工作站”。目前国内办事区域覆盖140多个重点城市，为全球30多个国家和地区的客户提供专业而高效的服务。" },
            { type: "section-heading", text: "主要展品" },
            { type: "paragraph", text: "良信聚焦四大核心创新成果，以“技术重构居住体验，科技赋能绿色生活”为理念，全方位呈现从家庭智能控制到能源高效管理的全链条解决方案。" },
            { type: "product-heading", text: "天启数字家庭综合箱" },
            { type: "image-group", images: [{ src: spotlightImage("zs_6_2.png"), alt: "天启数字家庭综合箱" }] },
            { type: "paragraph", text: "天启数字家庭综合箱以“化零为整”的创新思维，凭借全球首创的强弱电一体化数字技术，重新定义“好房子”的智能标准。该产品累计申请专利111项，将艺术审美与用电科技深度融合，让住宅成为集安全、舒适、绿色、智慧于一体的生活载体。" },
            { type: "product-heading", text: "LCB插拔式断路器" },
            { type: "image-group", images: [{ src: spotlightImage("zs_6_3.png"), alt: "LCB插拔式断路器" }] },
            { type: "paragraph", text: "LCB插拔式断路器以18毫米超薄尺寸实现漏电自检、远程控制、电能检测三大核心功能，凭借模块化颠覆设计，树立行业高效运维新标杆。" },
            { type: "product-heading", text: "户储解决方案" },
            { type: "image-group", images: [{ src: spotlightImage("zs_6_4.png"), alt: "户储解决方案" }] },
            { type: "paragraph", text: "围绕建筑光伏一体化与车储充场景一体化，为全球家庭提供全链路绿色能源管理方案。" },
            { type: "product-heading", text: "智能配电系统" },
            { type: "image-group", images: [{ src: spotlightImage("zs_6_5.png"), alt: "智能配电系统" }] },
            { type: "paragraph", text: "良信智能配电系统以技术突破实现合资替代，为企业园区零碳战略落地提供坚实支撑。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀各地市建设主管部门、各级城投公司、房地产开发商及上下游产业链相关合作伙伴莅临参观。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn。" },
        ],
    },
    {
        id: "urban-water-monitoring",
        title: "2026江苏绿色低碳建筑国际博览会展商|江苏城镇给排水监测有限公司",
        date: "2026-03-10",
        displayDate: "2026年3月10日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_7_1.jpg"), alt: "江苏城镇给排水监测有限公司" },
            { type: "paragraph", text: "江苏城镇给排水监测有限公司暨国家城市供水水质监测网南京监测站，是江苏省内唯一具备国家实验室认可（CNAS）与资质认定（CMA）双认证，能够对社会出具证明作用、具有公正性检测报告的实验室。业务覆盖检验检测服务、环境保护监测、技术研发推广、竞赛培训等多个领域。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "全流程智慧化实验室场景" },
            { type: "image-group", images: [{ src: spotlightImage("zs_7_2.png"), alt: "全流程智慧化实验室场景" }] },
            { type: "paragraph", text: "实验室汇聚国内顶尖机器人技术、无人采样、智能检测装备与5G算法优势，构建集智能感知、自动分析、精准研判、主动预警于一体的现代化监测体系，可按需提供个性化智能解决方案，打造全链条、一体化的集成服务。" },
            { type: "product-heading", text: "机械臂" },
            { type: "image-group", images: [{ src: spotlightImage("zs_7_3.jpg"), alt: "机械臂" }] },
            { type: "paragraph", text: "机械臂集成全自动样品抓取、瓶盖旋拧、自动取水等一体化作业功能，全程无需人工干预，可直接替代传统人工操作，大幅提升作业效率与稳定性。" },
            { type: "product-heading", text: "无人采样车" },
            { type: "image-group", images: [{ src: spotlightImage("zs_7_4.jpg"), alt: "无人采样车" }] },
            { type: "paragraph", text: "无人采样车可代替人工取水工作，具备多场景、全天候完全自动驾驶能力，室内、窄路均可灵活通行，可实现随时待命、远程指挥取水功能，提高应急能力。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "水务行业内有实验室新建、升级及改造需求的大中小企业，以及其他行业配备各类实验室、有相关需求的单位。如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn。" },
        ],
    },
    {
        id: "jsurcc",
        title: "2026江苏绿色低碳建筑国际博览会展商|江苏城乡建设职业学院",
        date: "2026-03-11",
        displayDate: "2026年3月11日",
        blocks: [
            { type: "logo", src: spotlightImage("zs_8_1.png"), alt: "江苏城乡建设职业学院" },
            { type: "paragraph", text: "江苏城乡建设职业学院隶属于省住建厅，始建于1986年，位于江苏常州，是省属公办高职、江苏省中国特色高水平高职学校。学校致力于绿色低碳建筑关键技术、智能建造、新型建筑工业化等领域教学与技术研发，拥有世界技能大赛中国集训基地，先后获评国家技能人才培育突出贡献单位、全国绿色低碳公共机构、全国健康学校建设单位等荣誉。" },
            { type: "section-heading", text: "主要展品" },
            { type: "paragraph", text: "展区主要设置学校荣誉、师德典范、技能闪耀、产教融合、社会服务等版块，展示学校在办学特色、人才培养与社会服务等方面的突出成果。现场布置中式花艺、木工技艺、彩绘面塑三个主题互动区域，同步展示师生作品。" },
            { type: "product-heading", text: "师生中式花艺作品展示" },
            { type: "image-group", images: [{ src: spotlightImage("zs_8_2.png"), alt: "师生中式花艺作品展示一" }, { src: spotlightImage("zs_8_3.png"), alt: "师生中式花艺作品展示二" }] },
            { type: "paragraph", text: "以“花艺互动交流，品创造之美”为主题，由花艺大师李昌贤与在校学生现场展示插花艺术，同时设置体验区，邀请观众参与捧花、盆栽、胸花等不同类型的项目体验，感受传统技艺的创造之美。" },
            { type: "product-heading", text: "师生木工技艺作品展示" },
            { type: "image-group", images: [{ src: spotlightImage("zs_8_4.png"), alt: "师生木工技艺作品展示一" }, { src: spotlightImage("zs_8_5.png"), alt: "师生木工技艺作品展示二" }] },
            { type: "paragraph", text: "以“木作技艺展示互动，传匠心之韵”为主题，由全国技术能手郭雨婷与在校学生现场展示传统木作技艺，通过现场制作书签、冰箱贴等趣味小物件，让观众体验榫卯拼装、雕刻技法等。" },
            { type: "product-heading", text: "师生彩绘面塑作品展示" },
            { type: "image-group", images: [{ src: spotlightImage("zs_8_6.png"), alt: "师生彩绘面塑作品展示" }] },
            { type: "paragraph", text: "以“彩绘泥塑工艺展示，续文化之脉”为主题，由建筑艺术学院陈爽老师与在校学生现场展示传统彩绘面塑技艺，现场制作具有中国传统特色、学校特色的小型面塑作品，供观众观赏与互动。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "主要面向建筑行业相关企业单位以及有升学需求的家长学生等，旨在展示学校各方面育人成效和办学成效。如您希望进行展前对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "xinxing-casting-pipe",
        title: "2026江苏绿色低碳建筑国际博览会展商|新兴铸管股份有限公司",
        date: "2026-03-14",
        displayDate: "2026年3月14日",
        blocks: [
            { type: "logo", src: spotlightImage("320-4-1.png"), alt: "新兴铸管股份有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "新兴铸管股份有限公司源于1971年成立的中国人民解放军第二六七二工程指挥部，1996年改制为国有独资公司，1997年在深交所上市。公司作为国资委监管中央企业“新兴际华集团”的核心企业，是全球最大的球墨铸铁管及管铸件研发制造商和国内最具竞争力的钢铁产品研发制造商。目前已形成战略布局优势、销售终端控制、生产成本优势、品牌价值优势、科技创新能力和企业文化优势六大核心竞争力，在全国各大区域和“一带一路”沿线国家建有众多生产基地，销售网络覆盖亚洲、欧洲、非洲、美洲等，产品出口世界120多个国家。" },
            { type: "section-heading", text: "展品简介" },
            { type: "product-heading", text: "01 球墨铸铁短顶管" },
            { type: "paragraph", text: "球墨铸铁短顶管施工采用非开挖技术，减少土方开挖和回填的工作量，不必拆除地面障碍物及较浅的地下障碍物。可以实现整体管线同材质同寿命，降低管线后期维护费用，提升管线安全性和经济效益。该产品具有密封性能好、内外防腐能力强、安装速度快、工作井开挖面积小等优势，可生产2米/支、1米/支、0.5米/支长度的顶管。" },
            { type: "image-group", images: [{ src: spotlightImage("320-4-2.png"), alt: "球墨铸铁短顶管" }] },
            { type: "product-heading", text: "02 球墨铸铁一体式检查井" },
            { type: "paragraph", text: "球墨铸铁一体式检查井的使用，可以有效解决管道及检查井内的漏水问题，对避免道路塌陷事故的发生、减少因检查井维修对交通的影响及解决进污水厂浓度偏低和城市内涝等问题都有社会和经济意义。球墨铸铁检查井产品具有强度高、承载能力强、密封性能好、使用寿命长、规格齐全、耐腐蚀能力强等特点。" },
            { type: "image-group", images: [{ src: spotlightImage("320-4-3.png"), alt: "球墨铸铁一体式检查井" }] },
            { type: "product-heading", text: "03 球墨铸铁雨污水管" },
            { type: "paragraph", text: "离心球墨铸铁雨污水管具有抵抗外部荷载能力强、适应地质条件变化范围广、管材强度高、韧性好、柔性接口施工快捷方便、施工成本低、使用寿命长等特点。" },
            { type: "image-group", images: [{ src: spotlightImage("320-4-4.png"), alt: "球墨铸铁雨污水管" }] },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "诚邀各地市主管部门、建设局、水务局、水利局、城投集团、水务集团、排水公司等工程建设单位、规划单位、设计单位、施工单位及科研院所等莅临参观。如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "cpic-pc-jss",
        title: "2026江苏绿色低碳建筑国际博览会展商|中国太平洋财产保险股份有限公司",
        date: "2026-03-15",
        displayDate: "2026年3月15日",
        blocks: [
            { type: "logo", src: spotlightImage("320-5-1.jpg"), alt: "中国太平洋财产保险股份有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "中国太平洋财产保险股份有限公司江苏分公司（简称“太保产险江苏分公司”）成立于1992年，属太平洋产险下设的一级分公司。公司始终坚持以客户需求为导向的发展战略，秉承“诚信天下、稳健一生、追求卓越、创新共赢”的核心价值观，专注保险主业、做精保险专业，不断提升服务水平、切实优化客户体验，年保单客户超过100万，年承保金额超过3万亿。公司先后获得“江苏保险业诚信服务先进单位”、“江苏省放心消费创建示范单位”等荣誉称号。" },
            { type: "section-heading", text: "展品简介" },
            { type: "product-heading", text: "01 水精灵触警应灾全流程机制" },
            { type: "paragraph", text: "太保水精灵以物联网技术为核心，可实时监测内涝风险并实现分级预警。中国太保产险江苏分公司坚持“效能优先、精准投放”原则，将系统重点部署于省内水淹高风险区域及重点行业，实现省内重点风险区域全覆盖。" },
            { type: "product-heading", text: "02 双光谱防火预警分析仪" },
            { type: "paragraph", text: "太保双光谱防火预警分析仪依托可见光与红外热成像双光谱融合技术，对重点区域进行全天候实时监测，精准识别烟雾、明火及异常高温等火灾隐患，实现早发现、早预警、早处置。设备可与平台系统联动，自动推送预警信息，提升火灾风险防控和应急响应能力，为园区、建筑及重点场所提供智能化安全保障。" },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "太保产险江苏分公司将举办建筑施工领域安全风险防控主题交流活动，聚焦房屋三项制度，就施工事故风险防控、安责险事故预防服务实践及智慧工地等新技术应用进行分享，并开展现场互动交流与答疑，促进事故预防经验交流。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀各地住房和城乡建设、应急管理、水务水利等政府主管部门，建筑施工、物业管理、园区运营、建筑安全、防灾减灾等领域的企业莅临参观。如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "beijing-wangzhi-yitong",
        title: "2026江苏绿色低碳建筑国际博览会展商|北京网智易通科技有限公司参展推介",
        date: "2026-03-16",
        displayDate: "2026年3月16日",
        blocks: [
            { type: "logo", src: spotlightImage("320-1-1.png"), alt: "北京网智易通科技有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "北京网智易通科技有限公司成立于2005年，是北京网智德实科技股份有限公司（股票代码：873476，简称：网智股份）全资子公司。公司以“给岁月以文明”为使命，深耕档案行业二十载，主营自主研发的档案信息化产品，业务涵盖 AI 数智档案系统、智能应用、数据治理、云计算及超融合备份容灾。公司致力于成为数字资产管理专家，为政府、企事业单位提供一体化档案解决方案。总部位于北京，拥有20余家分支机构，可提供全流程、体系化专业服务。" },
            { type: "section-heading", text: "展品简介" },
            { type: "paragraph", text: "网智科技新一代电子档案系统，严格对标行业标准及数字档案室建设规范。以“信创+AI+合规”为核心，提供“收、管、存、用、判”全生命周期解决方案。全栈适配国产化环境，筑牢安全屏障；深度融合AI技术，实现智能采集、合规管控与智慧赋能，全力支撑数字化转型与政务服务升级。" },
            { type: "image-group", images: [{ src: spotlightImage("320-1-2.png"), alt: "网智科技展品图一" }] },
            { type: "image-group", images: [{ src: spotlightImage("320-1-3.png"), alt: "网智科技展品图二" }] },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "北京网智易通科技有限公司以“国产化驱动数字化转型”为核心议题，构建“1场主峰会+ N场平行活动”的立体化架构，同步举办主题发布会、专业展区交流等配套活动。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀金融、军工、医疗、教育、能源等企业莅临参观，如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "kone-elevator",
        title: "2026江苏绿色低碳建筑国际博览会展商|通力电梯有限公司",
        date: "2026-03-16",
        displayDate: "2026年3月16日",
        blocks: [
            { type: "logo", src: spotlightImage("320-3-1.png"), alt: "通力电梯有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "通力致力于为建筑的全生命周期增添价值，提供创新且可持续的新梯解决方案，通过维保服务确保设备安全可靠地运行，并为老旧设备定制更新改造解决方案。自1996年进入中国以来，通力始终坚守“扎根中国、服务中国”的承诺，通力（昆山工业园）不仅是通力全球规模最大的生产基地，也是其在海外最大的研发中心，拥有通力全球最高的电梯地上测试塔，以及超过200项的有效专利。昆山工业园不仅满足国内市场的需求，产品出口至全球100多个国家和地区。通力在业内率先提出气候承诺，到2030年实现运营碳中和。2023年6月，通力成为全球首家实现生产碳中和的电扶梯企业。昆山工业园已实现100%绿电供应，并荣获国家级“绿色工厂”以及入选苏州“近零碳工厂”名单。" },
            { type: "image-group", images: [{ src: spotlightImage("320-3-2.jpg"), alt: "通力电梯有限公司展商图" }] },
            { type: "section-heading", text: "展品简介" },
            { type: "product-heading", text: "01 一站式旧梯改造服务" },
            { type: "paragraph", text: "通力电梯积极响应国家号召，以更适配老旧电梯的改造方案，实现全品牌电梯覆盖，为社区楼宇提供一站式旧梯改造服务，提升社区品质，守护居民出行，让城市更美好。从整梯焕新、灵活焕新，到智能焕芯，因楼制宜，打造安全、高效、绿色、智能的乘梯新体验。" },
            { type: "image-group", images: [{ src: spotlightImage("320-3-3.jpg"), alt: "一站式旧梯改造服务" }] },
            { type: "product-heading", text: "02 通力云管家" },
            { type: "paragraph", text: "通过对电扶梯维保需求的实时监测与智能分析，预先识别潜在故障，确保更卓越的产品性能，并显著优化乘梯体验，设备故障率降低约55%，困人风险减少约40%。18000+维保工程师，1000+服务站点，服务网络遍布全国，15秒响应，30分钟到达，24小时服务在线，通力金牌维保团队，是值得信赖的选择。" },
            { type: "image-group", images: [{ src: spotlightImage("320-3-4.png"), alt: "通力云管家" }] },
            { type: "product-heading", text: "03 通力DX智能电梯" },
            { type: "paragraph", text: "采用全新一代数字化控制系统，不仅能提供强大的算力支撑，还具备极佳的可扩展性；同时支持云端和本地端开放API接口，无缝连接多样化的解决方案和服务，助力构建智慧楼宇生态系统，定义未来电梯，为用户打造全新的乘梯体验。搭载的全新升级通力第五代EcoDisc碟式马达拥有国家一级能效认证，节能高达60%，降低电梯运行成本，带来全生命周期卓越的节能表现。" },
            { type: "image-group", images: [{ src: spotlightImage("320-3-5.png"), alt: "通力DX智能电梯" }] },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀各地政府、开发商、物业等莅临参观。如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "phoenix-real-estate",
        title: "2026江苏绿色低碳建筑国际博览会展商|江苏凤凰置业投资股份有限公司",
        date: "2026-03-17",
        displayDate: "2026年3月17日",
        blocks: [
            { type: "logo", src: spotlightImage("320-2-1.png"), alt: "江苏凤凰置业投资股份有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "江苏凤凰置业投资股份有限公司成立于2005年，2009年上市（凤凰股份 600716），是江苏省省属江苏凤凰出版传媒集团有限公司控股的上市公司，拥有5A合同能源管理证书、5A节能技术服务认证证书、5A综合能源服务认证证书和企业质量管理体系认证证书等资质认证。近年来，在保持地产开发主业基础上积极开展综合能源业务，是一家集绿色低碳住宅商业地产开发、既有建筑低碳节能改造、能源费用托管服务、零碳校园建设等多元业务于一体的综合性开发平台企业。公司已与江苏省委西康宾馆、南京河西外国语学校、凤凰集团总部等多家公共机构和企事业单位合作能源费用托管业务，公司自主研发的凤凰置业智慧能源管理平台也已在多项目成功应用。" },
            { type: "section-heading", text: "展品简介" },
            { type: "product-heading", text: "能源费用托管项目：南京河西外国语学校" },
            { type: "image-group", images: [{ src: spotlightImage("320-2-2.png"), alt: "南京河西外国语学校能源托管项目" }] },
            { type: "paragraph", text: "凤凰置业于2025年8月中标南京河西外国语学校能源费用托管服务项目，全面负责项目电、水、气能源供应，项目节能改造设计、投资建设以及所投资设备的后期运行维护管理。项目节能改造包含现场节能改造实施成果展示：" },
            { type: "image-group", images: [{ src: spotlightImage("320-2-3.png"), alt: "能源托管项目成果图一" }] },
            { type: "image-group", images: [{ src: spotlightImage("320-2-4.png"), alt: "能源托管项目成果图二" }] },
            { type: "product-heading", text: "凤凰置业能源智慧管理平台系统展示" },
            { type: "paragraph", text: "凤凰置业自研了能源智慧管理平台，此平台基于人工智能、物联网、大数据等技术，为项目搭建专属化、可视化、数据化、智能化、可扩展化智慧能源管理平台，面向公司能源管理项目多层次管理者及使用人员，提供用能单位能源设备系统运行全生命周期、多维度管理的综合运维管理。" },
            { type: "image-group", images: [{ src: spotlightImage("320-2-5.png"), alt: "凤凰置业能源智慧管理平台一" }] },
            { type: "image-group", images: [{ src: spotlightImage("320-2-6.png"), alt: "凤凰置业能源智慧管理平台二" }] },
            { type: "image-group", images: [{ src: spotlightImage("320-2-7.png"), alt: "凤凰置业能源智慧管理平台三" }] },
            { type: "paragraph", text: "通过实施以上节能改造措施，项目可获得以下收益：" },
            { type: "paragraph", text: "•可实现年节约电力81.4万kWh，其中绿色光伏电力替代57.8万kWh，年节水8000吨" },
            { type: "paragraph", text: "•项目总体节能率22.5%（含光伏）" },
            { type: "paragraph", text: "•预计每年减少515.6吨CO2排放量" },
            { type: "paragraph", text: "•提升能源使用舒适度，为师生身心健康及学校绿色可持续发展保驾护航" },
            { type: "paragraph", text: "•建立能源智慧管理平台实现能耗的智慧化管理和可视化管理，可作为节能综合展示和实践教育的综合示范平台，为学校的学生社会实践课提供实训环境" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀城市更新相关部门，公共机构、企事业单位、节能服务商等莅临参观。如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "sujiaoke-group",
        title: "2026江苏绿色低碳建筑国际博览会展商|苏交科集团股份有限公司",
        date: "2026-03-13",
        displayDate: "2026年3月13日",
        blocks: [
            { type: "logo", src: spotlightImage("zs-0326-1.png"), alt: "苏交科集团股份有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "苏交科集团股份有限公司成立于1978年，是基础设施领域全球领先的科技企业。作为国内首家工程咨询行业A股上市企业，拥有120多家子公司，在全球20多个国家设立分支机构，共有7000多名正式员工。集团致力于为客户提供创新性、引领性的一站式综合解决方案，拥有“三综一甲”行业顶级从业资质，业务涉及公路、市政、水运、铁路、航空和水利、电力等行业，覆盖亚欧美非四大洲60余个国家。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "“苏安慧”AI大模型应用平台" },
            { type: "image-group", images: [{ src: spotlightImage("zs-0326-2.jpg"), alt: "苏安慧AI大模型应用平台" }] },
            { type: "paragraph", text: "“苏安慧”AI大模型应用平台围绕排水专项中“数据复杂难用、处置依赖人工”等难点，部署本地大模型智能体，构建了“任务识别—数据调用—逻辑执行—结果生成”的自动化闭环流程。技术上平台突破传统模型在SQL精度、流程透明度、数据文本联动等方面的限制，形成语义解析+AI调度+规则响应的协同机制。已在排水场景中落地运行，日常报表填报周期从数天缩短至数小时，具备向其他专项复制推广的基础。" },
            { type: "product-heading", text: "城市内涝双算耦合嵌套模型" },
            { type: "image-group", images: [{ src: spotlightImage("zs-0326-3.png"), alt: "城市内涝双算耦合嵌套模型" }] },
            { type: "paragraph", text: "城市内涝双算耦合嵌套模型可准确预测未来2小时内涝风险点，支持根据积水原因提出针对性防控措施。模型采用模块化设计，可根据不同城市特点和业务需求灵活配置算法模块，具有良好的适应性和扩展性。该产品有效解决了市场现有水文水动力模型在保密性、准确性、计算效率等方面的问题，为城市内涝治理提供智能化决策工具。" },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "博览会同期举办城市基础设施生命线主题交流活动，聚焦工程建设、运维与安全管控全链条，邀请主管部门领导、行业专家及企业代表交流分享，发布先进技术成果与落地实践，搭建政产学研用协同平台，助力城市安全韧性提升。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀各地住房和城乡建设、市政园林、水务排水等政府主管部门，城市建设与运营管理单位，各地城投、水务集团等基础设施建设运营企业，各类产业园区、新区的建设管理主体及相关工程咨询合作方莅临参观。如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "cscec-science-industry",
        title: "2026江苏绿色低碳建筑国际博览会展商|中建科工集团有限公司",
        date: "2026-03-12",
        displayDate: "2026年3月12日",
        blocks: [
            { type: "logo", src: spotlightImage("zs-0326_2-1.png"), alt: "中建科工集团有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "中建科工集团有限公司是中国钢结构行业竞争力榜首企业、国家高新技术企业，隶属于世界500强中国建筑股份有限公司。公司聚焦以钢结构为主体结构的工程、装备业务，为客户提供“投资、研发、设计、建造、运营”全过程或核心环节的服务。公司打造了“中建科工”“中建钢构”两大品牌，分别从事“钢结构+”和钢结构，在国内和五大洲的42个国家和地区开展业务。2022年，中建钢构获评“国家单项冠军示范企业”和“世界一流专精特新示范企业”。" },
            { type: "section-heading", text: "主要展品" },
            { type: "product-heading", text: "钢构好房子" },
            { type: "paragraph", text: "以中建集团“好房子”营造体系为引领，深度融合中建科工自主研发的GS-Building钢结构装配式建筑体系，直面人民群众居住痛点，匠心打造兼具安全、舒适、绿色、智慧的钢结构高品质住宅，以科技力量推动人居体验持续升级。该体系以钢结构为核心承重主体，建筑的围护系统（包括外墙、内墙）、水电管线及设备、室内装修等关键部分，均采用工厂预制的标准化部品部件。通过一体化集成设计与现场装配化施工，实现从建造到智造的跨越，确保建筑品质更优、施工效率更高、居住环境更低碳环保。" },
            { type: "product-heading", text: "模块化建筑" },
            { type: "paragraph", text: "ME-House（模块化建筑）是中建科工自主研发的三维模块化绿色钢结构建筑产品。它将整栋建筑拆解成若干个独立的空间模块，每个模块在工厂里完成结构、装修、水电等全部工序，出厂即成为可直接拼装的“精装房间盒子”。产品以生态、宜居、智能、高效为核心特质，作为“1+N”全场景多元化建筑解决方案，可广泛应用于住宅、办公楼、学校、酒店、医院等多元场景，以工业化建造模式重构建筑产品形态与建造方式。" },
            { type: "image-group", images: [{ src: spotlightImage("zs-0326_2-2.png"), alt: "南京六合退役锂电池综合利用项目" }] },
            { type: "paragraph", text: "南京六合退役锂电池综合利用项目：该项目是南京市六合循环经济产业园重点产业项目、长三角退役锂电池综合利用标杆项目，更是落实国家“双碳”战略、推动新能源产业闭环发展的标志性工程。项目创新采用中建科工自研MEHouse模块化建筑体系，以“工厂智造、现场快装、绿色低碳、全生命周期可控”的新型建造模式，深度融合装配式建筑与循环经济产业需求，充分发挥高精度预制、高抗震可靠、高装配效率、低碳环保四大核心优势，全面破解传统产业园建设周期长、现场污染多、运维成本高的痛点。" },
            { type: "image-group", images: [{ src: spotlightImage("zs-0326_2-3.png"), alt: "加拿大MISSION模块化别墅项目" }] },
            { type: "paragraph", text: "加拿大MISSION模块化别墅项目：该项目是中建科工模块化建筑体系落地北美高端住宅市场的标杆项目。项目全面采用中建科工自研ME-House模块化建筑体系，以工厂预制、整装集成、快速拼装、抗震宜居、绿色低碳为核心优势，严格遵循北美建筑规范与高端居住标准，打造高品质、高舒适度、高交付效率的独栋别墅产品，为北美住宅市场提供中国工业化建造解决方案，树立海外高端模块化别墅典范工程。" },
            { type: "product-heading", text: "智能机器人" },
            { type: "paragraph", text: "中建科工深耕钢结构智能建造领域，聚焦行业核心工序，自主研发并应用除锈、焊接、切割、喷涂四大系列机器人。产品全面贴合行业规范，可适配工厂预制、现场施工等多元场景。机器人应用有效提升施工精准度与生产效率，降低劳动强度与环保压力，以智能技术助力钢结构建造实现提质增效，推动行业绿色低碳转型。" },
            { type: "image-group", images: [{ src: spotlightImage("zs-0326_2-4.png"), alt: "协作焊接机器人" }] },
            { type: "paragraph", text: "协作焊接机器人：该产品主要面向于建筑钢结构、工程机械、船舶和压力容器等行业，可针对各类复杂构件及狭小空间位置，实现高效、灵活、移动式精准焊接。具备操作简单、数字互联、多机协同等核心优势，工效提升42%，劳动强度降低75%，全面助力智能制造升级与现场作业提质减负。" },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "同期将开展战略合作洽谈签约，共商合作事项。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀各地方政府、各地住建部门、城投、城更、园区开发及大型国企集团、投资建设单位等莅临参观，如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "wuxi-urban-development-group",
        title: "2026江苏绿色低碳建筑国际博览会展商|无锡城建发展集团有限公司",
        date: "2026-03-18",
        displayDate: "2026年3月18日",
        blocks: [
            { type: "logo", src: spotlightImage("zs0325-3-1.png"), alt: "无锡城建发展集团有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "无锡城建发展集团有限公司组建于2020年12月，是无锡市政府直属企业，定位为集投资、建设、管理、运营为一体的国有资本投资运营主体和市场化综合运营服务商，主要承担城市建设及运营、乡村振兴、城市更新、生态环保、资产运作和产融服务等职能。截至2025年底，集团资产总额达1637亿元，连续四年入选中国服务业企业500强，国内主体信用评级为“AAA”，国际主体信用评级为“A+”。集团聚焦建设领域绿色发展，构建起覆盖投资、设计、智造、施工及运维的现代木结构建筑全产业链，推动木结构绿建在城市更新、园区建设、公共空间、美丽乡村、地产开发等多领域广泛应用。" },
            { type: "section-heading", text: "展品简介" },
            { type: "product-heading", text: "01 城市更新项目" },
            { type: "paragraph", text: "无锡城建集团紧扣城市更新战略要求，主动担当作为、落地成效显著：空间焕新提质增效，高质量完成梁溪河十里画廊等标杆示范项目，累计更新面积超120万平方米，多个项目入选国家级试点及典型案例；运营赋能精准发力，创新推行“公园+商业”融合模式，有效激活存量资产价值；民生服务暖心惠民，累计交付使用既有住宅加装电梯超450台；数字转型赋能升级，以数字化改革牵引城市更新全流程，深度运用AI技术推动场景落地，全面提升城市精细化管理质效。" },
            { type: "paragraph", text: "无锡古运河（东门段）城市更新项目贯穿火车站南广场和无锡老东门两大重点城市更新片区。项目计划总投资约247亿元，总占地面积约1.5平方公里，现状总建筑面积约247万平方米，计划保留建筑面积约138万平方米，改造建筑面积约63万平方米，拆除建筑面积约46万平方米，新建开发量约85万平方米。项目先后被列入无锡市级重点城市更新单元、江苏省城市更新首批省级试点项目，并入选老旧火车站及周边街区更新改造试点。" },
            { type: "paragraph", text: "项目形成“一河两街映三弄”的空间规划结构，布局六大街区产业功能，打造集数字科技、文化艺术、特色商业、总部经济、创新产业于一体的功能复合型活力片区。通过片区“留改拆”、老旧小区品质提升、传统产业焕新、公建配套完善、市政景观提升、实施二级开发和文化遗产保护等专项工作，重塑古运河片区文化魅力，提升片区生活品质。" },
            { type: "image-group", images: [{ src: spotlightImage("zs0325-3-2.jpg"), alt: "无锡古运河东门段城市更新项目" }] },
            { type: "product-heading", text: "02 现代木结构产业" },
            { type: "paragraph", text: "无锡城建发展集团构建了涵盖现代木结构设计、生产、施工、运维的全产业链，完成木结构施工项目达9万平方米。2025年，联合江苏省住房和城乡建设厅科技发展中心、南京工业大学，成功申报江苏省住房和城乡建设厅现代木结构工程技术创新中心，推动康欣新材研发HOSB、OST等新材料并实现工程应用，助力产业材料国产替代，以创新赋能建筑业绿色低碳发展。" },
            { type: "image-group", images: [{ src: spotlightImage("zs0325-3-3.jpg"), alt: "现代木结构产业" }] },
            { type: "product-heading", text: "03 既有建筑电梯加装" },
            { type: "paragraph", text: "聚焦既有住宅加装电梯这一社会关切，为民出发，从零起步，自2022年起从第一台至450台，助力4000余户家庭圆了“电梯梦”。坚持民生导向、科技创新和标准引领，构建起涵盖扶梯更新、别墅电梯、观光电梯、厂房电梯等多场景解决方案，形成既有住宅加装、老梯更新及新梯安装的全产业链布局。" },
            { type: "image-group", images: [{ src: spotlightImage("zs0325-3-4.jpg"), alt: "既有建筑电梯加装" }] },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "1. 江苏现代木结构创新实践与成果交流活动：结合行业发展趋势，报告省住建厅木结构创新中心建设进展与技术成果，介绍无锡城建发展集团木结构全产业链能力，并围绕双碳示范街区项目进行介绍与招商推介。" },
            { type: "paragraph", text: "2. 无锡城市更新经验分享暨产业招商对接活动：分享无锡城市更新创新做法和典型案例，介绍好房子、一体化停车、既有建筑加装电梯等城市更新配套服务，邀请优质地产商、运营商以及特色产业方参会，搭建对接合作平台。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "诚邀集中建设单位、政府平台型公司、城市更新单位、相关行业协会及设计、施工、文旅投资单位等莅临参观。如您希望进行贸易对接，请发送需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "wpg-smart-water",
        title: "2026江苏绿色低碳建筑国际博览会展商|威派格智慧水务",
        date: "2026-03-19",
        displayDate: "2026年3月19日",
        blocks: [
            { type: "logo", src: spotlightImage("zs0325-2-1.png"), alt: "威派格智慧水务" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "上海威派格智慧水务股份有限公司成立于2011年，于2019年2月22日在上海证券交易所挂牌上市（股票代码603956），是国内集水务行业规划咨询、专业智能硬件、行业物联网、水务专用软件与行业平台为一体的以工业互联网为核心理念的水务行业集成性科技公司。" },
            { type: "paragraph", text: "公司依托“智能硬件+专业软件+水务平台+行业物联网+全面服务”的一站式综合能力，为客户提供产品领先的“供排净治”全场景解决方案，涵盖智慧化水厂、水务管网、漏损产销差、二次供水、直饮水、农饮水、老旧小区供水改造等。" },
            { type: "section-heading", text: "展品简介" },
            { type: "product-heading", text: "01 二次供水展车" },
            { type: "paragraph", text: "威派格智慧供水移动展车以“威派格智慧水务，保障‘最后一公里’供水安全”为主线，涵盖“二供全流程业务场景、威派格智慧泵房、全系列智能硬件、全方位解决方案、全场景应用案例”五大主题。可零距离体验威派格二供新产品、新技术、新方案，推动绿色低碳发展，助力城市更新，为客户提供高效、可靠、智慧化的行业价值能力。" },
            { type: "image-group", images: [{ src: spotlightImage("zs0325-2-2.png"), alt: "威派格二次供水展车" }] },
            { type: "product-heading", text: "02 河图水务大模型平台" },
            { type: "paragraph", text: "为解决水务行业智能化转型中的三大核心需求，该底座融合NLP、机器学习、RAG、Agent及大模型等前沿技术，具备“开箱即用的AI应用构建能力”与“化繁为简的知识构建能力”。同时秉持平台化设计理念，拆解为水务大模型平台、算法平台、知识平台三大核心平台，打通技术与业务断层，驱动水务业务创新发展。" },
            { type: "image-group", images: [{ src: spotlightImage("zs0325-2-3.png"), alt: "河图水务大模型平台" }] },
            { type: "product-heading", text: "03 漏损治理管控平台" },
            { type: "paragraph", text: "威派格漏损管理系统作为漏损管理的信息化工具，在数据层面与GIS系统、营业系统、表务系统等基础数据采集平台进行深度整合，打破信息孤岛，为漏损管理系统提供数据基础。在功能层面通过DMA分区管理、多级大分区管理、远传大用户管理等功能模块的开发应用，实现分区计量、漏损控制、产销差管控综合信息管理体系建设。" },
            { type: "image-group", images: [{ src: spotlightImage("zs0325-2-4.png"), alt: "漏损治理管控平台" }] },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "同期将举办“供水管网漏损治理体系与路径”交流及智慧展车巡展活动，邀请行业专家学者围绕江苏区域分区计量漏损控制的针对性特色解决方案分享交流，发布先进技术成果。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "诚邀各地住房和城乡建设、水务水利等政府主管部门，各地城投、水务集团等基础设施建设运营企业，设计院、高校、相关工程咨询合作方莅临参观。如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "zhongyifeng-holding",
        title: "2026江苏绿色低碳建筑国际博览会展商|中亿丰控股集团有限公司",
        date: "2026-03-20",
        displayDate: "2026年3月20日",
        blocks: [
            { type: "logo", src: spotlightImage("zs0325-5-1.png"), alt: "中亿丰控股集团有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "中亿丰控股集团有限公司始于1952年，连续多年入围中国民营企业500强，是集城市建设、先进制造、科技孵化、产业金融、现代服务五大产业于一体的综合性建筑产业集团。集团旗下包括中亿丰建设、中亿丰罗普斯金、中亿丰数字科技、中亿丰地产、中亿丰文旅、中亿丰越南等100余家境内外控股子企业，其中罗普斯金在A股上市，3家公司在新三板挂牌，共有25家高新技术企业及10家专精特新企业。集团依托国家级专家领衔的多层次研发团队及省部级科技平台，以绿色工业设计为理念、DTCLOUD垂域大模型为技术底座，构建起绿色低碳、智能制造、智能建造三大新质生产力，已形成绿色建材、智能装备、数字智能、城市更新、好房子等特色产品体系。" },
            { type: "section-heading", text: "展品简介" },
            { type: "product-heading", text: "01 中亿丰“好房子”" },
            { type: "paragraph", text: "中亿丰“好房子”以“香山帮”工匠精神为根基，将苏州园林“可游、可居、可赏”的造园理想与现代人居需求相融合。公司充分发挥全产业链优势，立足地方特色与传统文化的当代转译，通过“三造”融合与“三链”协同的创新发展模式，构建起绿色低碳“好房子”智能建造与工业化产品服务体系，致力于打造既承袭园林雅韵、又引入当代科技的舒适宜居生活场景。" },
            { type: "paragraph", text: "•建筑工业化：装配式装修、建筑型材及系统门窗、机电设备" },
            { type: "paragraph", text: "•建筑绿色化：超低能耗住宅、BIPV、绿色建材" },
            { type: "paragraph", text: "•建造智能化：基于BIM的数字建造、建筑产业互联网平台" },
            { type: "paragraph", text: "•产业数字化：工业互联网、智能家居、智慧社区" },
            { type: "product-heading", text: "02 智能施工升降机" },
            { type: "paragraph", text: "智能施工升降机是在传统施工升降机基础上进行自动化和智能化升级，配置自动层门，可响应楼层外呼和笼内选层指令，也可通过垂直物流调度系统响应建筑机器人的搭乘请求，并在指定楼层自动平层停靠、自动开关门。设备在提高安全性、降低成本、提高施工效率、推进智慧工地运营等方面具有显著优势，可有效解决传统施工升降机使用效率低下的弊端，为建筑工程施工进度保障和智慧工地推进提供有力支持。" },
            { type: "product-heading", text: "03 DTCLOUD亿智云" },
            { type: "paragraph", text: "作为自主研发的全国首个智能建造工业互联网平台，DTCLOUD亿智云是中亿丰深耕智能建造产业的核心产品，以“BIM+AIoT数字孪生”为核心技术支撑，创新打造“1平台+6专项”产品与服务体系，业务覆盖BIM数字一体化设计、部品化智能生产、智能装备及建筑机器人应用、智能施工管理、智慧运维等全产业链关键环节，相关技术成果与应用实践获得行业广泛认可，综合实力位居全国领先行列。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀投资端、建设端、运营端、产品端等领域的企业客户莅临参观。如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "cscec-international-construction",
        title: "2026江苏绿色低碳建筑国际博览会展商|中建国际建设有限公司",
        date: "2026-03-21",
        displayDate: "2026年3月21日",
        blocks: [
            { type: "logo", src: spotlightImage("zs0325-4-1.png"), alt: "中建国际建设有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "中建国际建设有限公司总部设在北京和苏州，是中国建筑集团旗下唯一国内总部、以海外业务为主、国内外一体化发展的二级子企业。作为中国建筑海外业务孵化、投资与模式升级平台，公司肩负引领系统内企业“走出去”、开拓海外市场、探索新模式、推动集团海外业务高质量发展的重任，紧抓对外开放机遇，紧扣集团“一创五强”战略，践行“拓展幸福空间”使命，深度参与“一带一路”建设，以创新驱动发展，致力成为中国建筑海外事业引领者，为全球客户提供投建营一体化服务，助力中国建筑建设世界一流企业。" },
            { type: "section-heading", text: "展品简介" },
            { type: "paragraph", text: "中建国际聚焦建筑低碳转型，研发建筑碳排放智慧监管、楼宇数字孪生运维等数字化平台，集成全能源品类的碳排放监测设备矩阵，推出智慧灯杆、无机相变储能等绿色低碳产品，为行业提供标准化、可复制的低碳转型系统解决方案。" },
            { type: "product-heading", text: "01 中国建筑碳排放监测与管理综合服务平台" },
            { type: "paragraph", text: "依托集团重大科研课题，研发中国建筑碳排放监测与管理综合服务平台，为集团碳排放的管理分析和管理决策提供智慧工具。平台由两大主系统、四大子系统、三大数据库组成，通过平台可实现集团碳排放数据的采集、分析、核算、统计与分析报告。" },
            { type: "image-group", images: [{ src: spotlightImage("zs0325-4-2.png"), alt: "中国建筑碳排放监测与管理综合服务平台" }] },
            { type: "product-heading", text: "02 智慧楼宇运维平台" },
            { type: "paragraph", text: "通过构建集智能化、可视化和协同化管理于一体的运营控制中心，该平台作为“中建国际大脑”，对项目中已建设的19个子系统进行综合管控、对管理行为进行监督，实现对项目运行、运维、运营管理的监督，为项目数字化运营提供技术和数据赋能。" },
            { type: "image-group", images: [{ src: spotlightImage("zs0325-4-3.png"), alt: "智慧楼宇运维平台" }] },
            { type: "product-heading", text: "03 新型数字化结构韧性增强装备" },
            { type: "paragraph", text: "中建国际自主研发的新型数字化结构韧性增强装备，聚焦工程结构的安全减震需求，打造了宽频带、可数控、自适应的系列化阻尼产品。其中气液阻尼装置可实现宽频范围的阻尼效果精准调控，节省空间30%以上；程控风阻阻尼装置突破传统技术局限，无需笨重的质量块，体积小巧不占用空间，创新实现“以风制风”的智能减震。系列装备可广泛用于超高层高耸结构、大跨建筑等领域，以数字化技术全方位提升工程结构的抗振韧性与长期安全性能。" },
            { type: "image-group", images: [{ src: spotlightImage("zs0325-4-4.png"), alt: "新型数字化结构韧性增强装备" }] },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀各地住房城乡建设主管部门，建筑施工、物业管理、园区运营、建筑安全等领域的地产开发企业和运维公司莅临参观。如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "jiangsu-shanyou-tech",
        title: "2026江苏绿色低碳建筑国际博览会展商|江苏航天山由科技有限公司",
        date: "2026-03-22",
        displayDate: "2026年3月22日",
        blocks: [
            { type: "logo", src: spotlightImage("zsxw_logo_1.png"), alt: "江苏航天山由科技有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "江苏航天山由科技有限公司是中国航天科技集团有限公司旗下国有控股企业，主要研发和制造汽车膜、建筑玻璃用功能膜及特种防护膜。生产基地布局江苏常州、陕西西安，年产能达8000万平方米。公司现有授权专利68件，掌握精密涂布、光谱选择控制、表面处理、功能材料相容复配、颜色调节及保固等核心生产技术，攻克多项行业长期存在的技术难题。公司通过ISO9001质量管理体系、ISO14001环境管理体系等认证，是国家高新技术企业、江苏省高性能光学薄膜材料工程技术研究中心、江苏省认定企业技术中心，也是江苏省专精特新中小企业。" },
            { type: "section-heading", text: "产品简介" },
            { type: "paragraph", text: "•建筑隔热膜：以聚酯膜为基片，镀有高强防护层，经金属化镀层磁控溅射等工艺制成，具备隔热保暖、防噪、安全防护等功能，可有效保护建筑玻璃。" },
            { type: "paragraph", text: "•建筑隐私膜：主打隐私遮蔽功能，营造私密舒适的空间环境。" },
            { type: "paragraph", text: "•建筑装饰膜：兼具装饰美化效果，可打造个性化DIY空间，适用于玻璃移门、玻璃橱柜门、办公隔断等场景。" },
            { type: "paragraph", text: "•建筑防爆膜：借助聚酯薄膜抗张强度赋予玻璃内张应力，基础款安全膜可让玻璃抵御板砖、钢管等强烈冲击，做到不裂不碎。" },
            { type: "paragraph", text: "•建筑家居膜：采用高清光学基材、高性能胶黏剂，搭配专业表面处理工艺，耐磨抗划伤、抗污增亮、环保零污染，广泛适用于家居、公共场所等领域。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀建筑设计院、节能建材商、玻璃厂家等莅临参观，如您希望进行展前贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "beijing-xietong-weiye",
        title: "2026江苏绿色低碳建筑国际博览会展商|北京协通伟业科技有限责任公司",
        date: "2026-03-26",
        displayDate: "2026年3月26日",
        blocks: [
            { type: "logo", src: spotlightImage("330-1-1.png"), alt: "北京协通伟业科技有限责任公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "北京协通伟业科技有限责任公司是国内住房金融信息化领域的专业性技术服务商，总部位于北京，在常州、成都设分公司，构建了全国范围高效服务网。公司深耕住房公积金行业信息系统建设30余年，参编多项行业标准，核心成员均具有10年以上行业经验，具备丰富的大型项目实施经验，具备覆盖咨询、研发、建设、集成、运维的全链条服务能力，公司目前服务全国40余个公积金中心。在数字化、智能化发展进程中，协通伟业以数据驱动发展，深度融合人工智能技术，打造了全新一代数智公积金信息系统，积极推动公积金数字化转型，实现高质量发展。" },
            { type: "section-heading", text: "展品简介" },
            { type: "paragraph", text: "协通伟业新一代数字公积金产品旨在将数字技术广泛应用于住房公积金管理服务，推进业务流程优化、模式创新和履职能力提升，以贯彻新版《住房公积金基础数据标准》为基础，打造“1+3+5”的数字化建设总体框架。其中，“1”指筑牢数字化基础底座，“3”指建设业务中台、技术中台、数据中台三大中台，“5”指打造综合业务系统、综合管理系统、综合服务系统、数据应用系统和风险防控系统五大特色应用。" },
            { type: "image-group", images: [{ src: spotlightImage("330-1-2.png"), alt: "协通伟业展品图" }] },
            { type: "section-heading", text: "同期活动" },
            { type: "paragraph", text: "以“数智公积金”为主题，同步举办产品发布会、行业技术交流等同期活动，围绕省内各住房公积金中心在业务流程优化、信息化系统建设、数据应用创新等方面的实践经验开展分享交流。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "诚邀住房金融相关单位莅临参观，如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "lianfa-group",
        title: "2026江苏绿色低碳建筑国际博览会展商|联发集团有限公司",
        date: "2026-03-27",
        displayDate: "2026年3月27日",
        blocks: [
            { type: "logo", src: spotlightImage("330-2-1.png"), alt: "联发集团有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "联发集团有限公司成立于1983年，是世界500强企业厦门建发集团旗下核心行业集团。集团深耕房地产开发主业，业务覆盖全国28座重点城市，累计开发面积超2100万平方米，服务近50万业主，土地储备超1000万平方米。项目围绕“新澍系”“悦系”“嘉和系”三个体系，针对城市新青年等开发建设高品质居住空间。联发集团在南京开发了雨花新澍、嘉和华府等8个房地产项目，广泛获得市场好评。" },
            { type: "section-heading", text: "展品简介" },
            { type: "paragraph", text: "雨花新澍项目位于软件谷板块，规划建面约69-133m²，空间利用率高、交通便捷、教育配套完善。项目设置多元功能空间，可满足居民健身、休闲、办公、亲子等需求，业主可通过联发开发的超级APP线上预约使用，生活配套齐全，可满足职住平衡。" },
            { type: "image-group", images: [{ src: spotlightImage("330-2-2.png"), alt: "雨花新澍项目展示图一" }] },
            { type: "image-group", images: [{ src: spotlightImage("330-2-3.jpg"), alt: "雨花新澍项目展示图二" }] },
            { type: "image-group", images: [{ src: spotlightImage("330-2-4.jpg"), alt: "雨花新澍项目展示图三" }] },
            { type: "paragraph", text: "该项目通过建设高标准智慧社区，打造“New Life OS智慧社区系统”，社区公共空间实现24小时AI安全守护、无感便捷通行；室内空间全面搭载华为鸿蒙智家系统，通过智能中控屏或手机APP，可一键控制灯光、空调等。" },
            { type: "image-group", images: [{ src: spotlightImage("330-2-5.jpg"), alt: "New Life OS智慧社区系统展示图" }] },
            { type: "section-heading", text: "现场活动" },
            { type: "paragraph", text: "现场将举办青年购房分享会，邀请房地产专家现场进行购房政策、贷款政策、房票政策等公益分享及服务。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀有购房意向的客户莅临参观，如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "renshuo-solar-suzhou",
        title: "2026江苏绿色低碳建筑国际博览会展商|仁烁光能（苏州）有限公司",
        date: "2026-03-23",
        displayDate: "2026年3月23日",
        blocks: [
            { type: "logo", src: spotlightImage("330-3-1.png"), alt: "仁烁光能（苏州）有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "仁烁光能成立于2021年底，面向国家双碳战略，立足国际科技前沿，专注新型高效钙钛矿光伏组件的研发与制造。钙钛矿技术全球领先，先后13次打破世界钙钛矿光伏光电转换效率纪录，已申请核心专利150余项，关键技术入选“中国科学十大进展”，是国家认证的高新技术企业、专精特新企业。公司平米级商用组件的效率和可靠性通过国际权威认证和市场检验，远销海内外，是行业领军企业、国家潜在独角兽企业。" },
            { type: "section-heading", text: "展品简介" },
            { type: "product-heading", text: "01 烁光钙钛矿采光顶" },
            { type: "paragraph", text: "烁光是融合光伏发电与建筑采光的创新解决方案，将高效发电功能与建筑采光需求完美结合，为建筑披上既能发电又能透光的“智能皮肤”。" },
            { type: "image-group", images: [{ src: spotlightImage("330-3-2.png"), alt: "烁光钙钛矿采光顶" }] },
            { type: "product-heading", text: "02 烁彩钙钛矿采光顶" },
            { type: "paragraph", text: "烁彩是融合光伏发电与建筑采光的创新解决方案，将高效发电功能与建筑采光需求完美结合，为建筑披上既能发电又能透光的“智能皮肤”。" },
            { type: "image-group", images: [{ src: spotlightImage("330-3-3.png"), alt: "烁彩钙钛矿采光顶" }] },
            { type: "product-heading", text: "03 烁瓦钙钛矿光伏瓦" },
            { type: "paragraph", text: "烁瓦是颠覆传统太阳能板的新型建筑光伏一体化材料，将高效发电功能与建筑瓦片结构完美融合，让屋顶在保持美观的同时成为一个小型清洁电站。" },
            { type: "image-group", images: [{ src: spotlightImage("330-3-4.png"), alt: "烁瓦钙钛矿光伏瓦" }] },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "诚邀各界合作伙伴、行业专家及媒体朋友莅临参观，如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "shanghai-mitsubishi-elevator",
        title: "2026江苏绿色低碳建筑国际博览会展商|上海三菱电梯有限公司",
        date: "2026-03-26",
        displayDate: "2026年3月26日",
        blocks: [
            { type: "logo", src: spotlightImage("330-4-1.jpg"), alt: "上海三菱电梯有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "上海三菱电梯有限公司成立于1987年1月，是电梯行业唯一国有控股合资企业，公司投资总额2亿美元，占地面积39.23万平方米，员工总数超15000人。2024年发布LEHY-Pro12.5m/s超高速电梯，刷新了国产电梯速度纪录。2025年产销售电梯9万台，营业收入超180亿元，累计产销超140万台、出口超3万台。先后荣获中国质量奖提名、全国质量奖、全国文明单位、国家级智能制造示范工厂等多项荣誉。" },
            { type: "section-heading", text: "展品简介" },
            { type: "product-heading", text: "01 旧梯更新改造" },
            { type: "paragraph", text: "上海三菱电梯深耕老旧电梯更新事业，全国累计更新改造超10万台，以专业技术、全流程服务与专项团队，持续领跑电梯更新改造市场。关注客户需求和痛点，为客户度身定制电梯全拆全换、保留部件和菱动焕新等多种方案，推出1:1绕绳比的更新改造专用产品LEHY-N，同时应用最新的智慧电梯数字化技术，提升客户乘梯品质。" },
            { type: "image-group", images: [{ src: spotlightImage("330-4-2.jpg"), alt: "旧梯更新改造" }] },
            { type: "product-heading", text: "02 超高速乘客电梯" },
            { type: "paragraph", text: "超高速乘客电梯专为超高层建筑、高端办公、酒店地标等场景设计，以强劲性能应对高空运输需求。" },
            { type: "image-group", images: [{ src: spotlightImage("330-4-3.jpg"), alt: "超高速乘客电梯" }] },
            { type: "product-heading", text: "03 LNK智慧电梯数字化解决方案" },
            { type: "paragraph", text: "LNK智慧电梯数字化解决方案涵盖智慧管梯、智慧乘梯、智慧互联、智慧服务四个维度，面向开发商、物业、乘客及政府监管部门等提供基于物联网的数字化方案。首创的多个解决方案产品，提升了用户呼梯、候梯体验与楼宇运输效率，助力建筑数字化。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀房地产开发商、各类企事业单位、交通枢纽、老旧小区改造项目及高端住宅与别墅业主等全场景客户莅临参观。如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "cscec-fifth-engineering-bureau",
        title: "2026江苏绿色低碳建筑国际博览会展商|中国建筑第五工程局有限公司",
        date: "2026-03-24",
        displayDate: "2026年3月24日",
        blocks: [
            { type: "logo", src: spotlightImage("330-5-1.png"), alt: "中国建筑第五工程局有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "中建五局是中国建筑的全资骨干企业，拥有房屋建筑工程施工总承包、市政公用工程施工总承包、公路工程施工总承包3个特级资质和相对应的设计甲级资质，以及风景园林工程设计专项甲级资质，拥有电力、水利水电总承包一级资质，隧道、环保等专业资质。总资产超2000亿元，累计投资额超6000亿元，年合同额超4000亿元、营业额超2000亿元，是集投资商、建造商、运营商“三商一体、品质一流”的现代化投资建设集团。" },
            { type: "section-heading", text: "展品简介" },
            { type: "product-heading", text: "01 旧改好房子" },
            { type: "paragraph", text: "针对老旧小区普遍存在的设施老化、功能缺失、改造难度大等痛点，中建五局深度结合既有建筑改造的人文需求与技术创新，提炼出 “诊、拆、改、提”旧改四字诀。同时，紧扣住建部关于“人民需求好房子”的核心要求，量身打造“药到病除”的一站式解决方案，创新应用12项新技术、16种新产品及材料、6种新工艺，形成了系列化的旧改创新技术与产品体系。这不仅为旧改工作注入了新质生产力，更实现了从“老房子”到“好房子”的全方位蜕变，让“人民对美好生活的向往，就是我们的奋斗目标”这一理念，真正落地于每一处改造细节。" },
            { type: "image-group", images: [{ src: spotlightImage("330-5-2.jpg"), alt: "长沙信和苑小区改造前后对比图一" }, { src: spotlightImage("330-5-3.jpg"), alt: "长沙信和苑小区改造前后对比图二" }] },
            { type: "paragraph", html: "<span style='display:block;text-align:center;text-indent:0;'>▲长沙信和苑小区改造前后对比图</span>" },
            { type: "product-heading", text: "02 城运慧系统" },
            { type: "paragraph", text: "城运慧是中建五局数科公司打造的城市级综合运营管理平台，以“一网一库一图一底座一平台+N应用”架构，集成四大智慧功能、30项核心模块，覆盖六大运营场景，依托四大中台实现数智化管理，已落地数百个项目，适配性与实用性突出。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀公建装修改造需求方，旧房改造业主，商业地产商及环卫、物业服务商等莅临参观。如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
    {
        id: "cscec-ecological-environment-group",
        title: "2026江苏绿色低碳建筑国际博览会展商|中建生态环境集团有限公司",
        date: "2026-03-25",
        displayDate: "2026年3月25日",
        blocks: [
            { type: "logo", src: spotlightImage("330-6-1.png"), alt: "中建生态环境集团有限公司" },
            { type: "section-heading", text: "展商简介" },
            { type: "paragraph", text: "中建生态环境集团有限公司成立于2013年12月，致力于成为“生态环保行业领先的投资建设运营集团”“建筑行业领先的低碳管理综合服务商”“中国建筑旗下环保运营业务最专业公司”。公司积极践行“两山”理念，响应“双碳”目标，发挥“资本+运营+科技”三大引擎驱动，形成水务水利、环境科技、能碳科技、高端水科技四大业务板块。公司拥有市政壹级、建筑机电壹级等7项工程设计与施工资质，污水处理设施、排水管道监测等8项运营及检测资质，以及近零能耗建筑第三方测评机构等双碳服务资质。" },
            { type: "section-heading", text: "展品简介" },
            { type: "product-heading", text: "01 IOE边缘自控建筑节能降碳设备" },
            { type: "paragraph", text: "中建生态环境集团自主研发的一套建筑边缘感知与节能管理设备，主要用于办公、商业等场景，可根据建筑内不同场景，微动感知房间内人员和环境状态，采用人工智能优化算法，自动调整照明、插座、空调等设备的运行状态和设定参数，实现全自动管理，从而降低建筑运行能耗，同时减少人工管理成本和建筑运行阶段的碳排放。" },
            { type: "image-group", images: [{ src: spotlightImage("330-6-2.png"), alt: "IOE边缘自控建筑节能降碳设备" }] },
            { type: "product-heading", text: "02 建筑AI低碳运营平台" },
            { type: "image-group", images: [{ src: spotlightImage("330-6-3.png"), alt: "建筑AI低碳运营平台" }] },
            { type: "paragraph", text: "结合人工智能技术自主研发的建筑行业AI低碳运营平台，借助AI通用大模型，以建筑领域专业知识、复杂问题处理能力的垂直大模型为核心，结合多年专业技能经验，形成建筑低碳运营核心算法，不断优化控制建筑系统运行效率，深挖建筑节能降碳潜力。" },
            { type: "product-heading", text: "03 净氟生态舱" },
            { type: "image-group", images: [{ src: spotlightImage("330-6-4.png"), alt: "净氟生态舱" }] },
            { type: "paragraph", text: "对于电子废水处理行业，氟化物作为新兴特征污染因子，处理难度远超传统污染物，中建生态环境集团自主研发净氟生态舱，集高效除氟、资源循环、生态修复于一体的新型水处理系统，通过生态化集成设计和多技术协同，解决了传统工艺成本高、能耗高、二次污染、生态兼容性差等痛点。" },
            { type: "product-heading", text: "04 高品质再生水小分子污染物去除工艺包" },
            { type: "image-group", images: [{ src: spotlightImage("330-6-5.png"), alt: "高品质再生水小分子污染物去除工艺包" }] },
            { type: "paragraph", text: "公司自主研发的小分子污染物去除工艺包，通过靶向微生物，提高小分子污染物去除效率，降低运营成本，不引入污染物，无二次污染，为高品质再生水厂运营提供技术保障。" },
            { type: "product-heading", text: "05 零碳园区规投建运一体化服务" },
            { type: "image-group", images: [{ src: spotlightImage("330-6-6.png"), alt: "零碳园区规投建运一体化服务" }] },
            { type: "paragraph", text: "综合采用“降低负荷能耗+提升能源利用能效+可再生能源充分利用”的技术路径，搭建微电网平台、AI能碳管理平台、零碳园区全过程管控平台等，为零碳园区创建及产业高质量低碳发展提供一揽子解决方案。" },
            { type: "section-heading", text: "现场活动" },
            { type: "paragraph", text: "现场将集中展示“IOE边缘自控建筑节能降碳设备”“建筑AI低碳运营平台”“净氟生态舱”“高品质再生水小分子污染物去除工艺包”“零碳园区规投建运一体化服务”等核心技术成果，并举办现场演示和沉浸式体验活动。" },
            { type: "section-heading", text: "目标客户" },
            { type: "paragraph", text: "我们诚邀各地建设主管部门、园区管委会、建筑运营方等莅临参观，如您希望进行贸易对接，请发送您的需求至邮箱：gbie@gbservice.cn，我们将第一时间与您联系。" },
        ],
    },
];

const hydrate0407SpotlightBlocks = (blocks = []) =>
    blocks.map((block) => {
        if (!block) {
            return block;
        }

        if (block.type === "image" && block.src) {
            return {
                ...block,
                src: spotlightImage(block.src),
            };
        }

        if (block.type === "image-group" && Array.isArray(block.images)) {
            return {
                ...block,
                images: block.images.map((image) => ({
                    ...image,
                    src:
                        image && image.src
                            ? spotlightImage(image.src)
                            : image.src,
                })),
            };
        }

        return block;
    });

const EXHIBITOR_SPOTLIGHT_0407 = SPOTLIGHT_NEWS_0407.map((item) => ({
    ...item,
    cover: item.cover ? spotlightImage(item.cover) : undefined,
    blocks: hydrate0407SpotlightBlocks(item.blocks),
}));

export const EXHIBITOR_SPOTLIGHT_NEWS = [
    ...EXHIBITOR_SPOTLIGHT_BASE_NEWS,
    ...EXHIBITOR_SPOTLIGHT_0407,
    ...EXHIBITOR_SPOTLIGHT_EXTRA_NEWS.map((item) => ({
        ...item,
        englishOnly: true,
    })),
].sort(sortNewsByDateDesc);

const normalizeLocale = (locale) => (locale === "en" ? "en" : "zh");

const formatDisplayDate = (date, locale) => {
    if (!date) {
        return "";
    }

    const normalizedLocale = normalizeLocale(locale);
    const dateMatch = String(date).match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (normalizedLocale === "en" && dateMatch) {
        return `${dateMatch[1]}.${dateMatch[2]}.${dateMatch[3]}`;
    }

    try {
        return new Intl.DateTimeFormat(
            normalizedLocale === "en" ? "en-US" : "zh-CN",
            {
                year: "numeric",
                month: "long",
                day: "numeric",
            }
        ).format(new Date(date + "T00:00:00"));
    } catch (error) {
        return date;
    }
};

const resolveLocalePayload = (article) => {
    const localized = article.i18n || {};
    const zh = localized.zh || {};
    const en = localized.en || {};
    const englishDoc = EXHIBITOR_SPOTLIGHT_EN_DOCS[article.id] || {};

    return {
        zh: {
            title: zh.title || article.title || "",
            displayDate: zh.displayDate || article.displayDate || "",
            blocks: zh.blocks || article.blocks || [],
        },
        en: {
            title: en.title || article.enTitle || englishDoc.title || "",
            displayDate:
                en.displayDate ||
                article.enDisplayDate ||
                englishDoc.displayDate ||
                "",
            blocks: en.blocks || article.enBlocks || englishDoc.blocks || [],
        },
    };
};

const localizeImageGroupImages = (zhImages = [], enImages = []) =>
    zhImages.map((image, index) => {
        const translatedImage = enImages[index] || {};

        return {
            ...image,
            ...translatedImage,
            alt: translatedImage.alt || image.alt,
            src: translatedImage.src || image.src,
        };
    });

const localizeBlock = (zhBlock, enBlock) => {
    const merged = {
        ...zhBlock,
        ...(enBlock || {}),
    };

    if (zhBlock.type === "image-group") {
        merged.images = localizeImageGroupImages(
            zhBlock.images || [],
            (enBlock && enBlock.images) || []
        );
    }

    if (zhBlock.text !== undefined || (enBlock && enBlock.text !== undefined)) {
        merged.text = (enBlock && enBlock.text) || zhBlock.text || "";
    }

    if (
        zhBlock.caption !== undefined ||
        (enBlock && enBlock.caption !== undefined)
    ) {
        merged.caption = (enBlock && enBlock.caption) || zhBlock.caption;
    }

    if (zhBlock.alt !== undefined || (enBlock && enBlock.alt !== undefined)) {
        merged.alt = (enBlock && enBlock.alt) || zhBlock.alt;
    }

    if (zhBlock.src !== undefined || (enBlock && enBlock.src !== undefined)) {
        merged.src = (enBlock && enBlock.src) || zhBlock.src;
    }

    return merged;
};

const dedupeSpotlightNewsById = (items = []) => {
    const seen = new Set();
    return items.filter((item) => {
        if (!item || !item.id) {
            return false;
        }
        if (seen.has(item.id)) {
            return false;
        }
        seen.add(item.id);
        return true;
    });
};

const SPOTLIGHT_NEWS_UNIQUE = dedupeSpotlightNewsById(
    EXHIBITOR_SPOTLIGHT_NEWS
);

const localizeArticle = (article, locale) => {
    const normalizedLocale = normalizeLocale(locale);
    const payload = resolveLocalePayload(article);
    const fallback = payload.zh;
    const zhBlocks = Array.isArray(fallback.blocks) ? fallback.blocks : [];

    if (normalizedLocale === "en") {
        const enPayload = payload.en;
        const enTitle = typeof enPayload.title === "string" ? enPayload.title.trim() : "";
        const enBlocks = Array.isArray(enPayload.blocks)
            ? enPayload.blocks.map((block) => localizeBlock(block, null))
            : [];
        const hasEnglishContent = enTitle !== "" && enBlocks.length > 0;

        return {
            ...article,
            title: enTitle || fallback.title,
            hasEnglishContent,
            displayDate: enPayload.displayDate || formatDisplayDate(article.date, "en"),
            blocks: enBlocks,
        };
    }

    return {
        ...article,
        title: fallback.title,
        hasEnglishContent: false,
        displayDate:
            fallback.displayDate ||
            formatDisplayDate(article.date, "zh"),
        blocks: zhBlocks.map((block) => localizeBlock(block, null)),
    };
};

export function getExhibitorSpotlightNews(locale = "zh") {
    const normalizedLocale = normalizeLocale(locale);
    const localized = SPOTLIGHT_NEWS_UNIQUE.filter((item) =>
        normalizedLocale === "zh" ? !item.englishOnly : true
    ).map((item) => localizeArticle(item, locale));

    if (normalizedLocale === "en") {
        return localized.filter((item) => item.hasEnglishContent);
    }

    return localized;
}

export function findExhibitorSpotlightById(id, locale = "zh") {
    const normalizedLocale = normalizeLocale(locale);
    const target = SPOTLIGHT_NEWS_UNIQUE.find((item) => item.id === id);
    if (!target) {
        return null;
    }
    if (normalizedLocale === "zh" && target.englishOnly) {
        return null;
    }
    const localized = localizeArticle(target, locale);
    if (normalizedLocale === "en" && !localized.hasEnglishContent) {
        return null;
    }
    return localized;
}
